document.addEventListener('DOMContentLoaded', function() {
    var headings = document.querySelectorAll('.footer-block__heading');

    headings.forEach(function(heading) {
      heading.addEventListener('click', function() {
        var parent = heading.parentElement;
        var content = parent.querySelector('.footer-block__details-content');

        // Si ya está activo, desactivar
        if (content.classList.contains('fiido_mobile_footer_active')) {
          content.classList.remove('fiido_mobile_footer_active');
          content.style.height = '0';
        } else {
          // Ocultar todos los contenidos activos y mostrar el contenido actual
          var allContents = document.querySelectorAll('.footer-block__details-content');
          allContents.forEach(function(item) {
            item.classList.remove('fiido_mobile_footer_active');
            item.style.height = '0';
          });

          content.classList.add('fiido_mobile_footer_active');
          content.style.height = content.scrollHeight + 'px';
        }
      });
    });
});